export enum PeriodType {
  Year,
  Month,
  Week,
}
